import { render, staticRenderFns } from "./StatementDescriptor.vue?vue&type=template&id=3e3b62ee&scoped=true&"
import script from "./StatementDescriptor.vue?vue&type=script&lang=js&"
export * from "./StatementDescriptor.vue?vue&type=script&lang=js&"
import style0 from "./StatementDescriptor.vue?vue&type=style&index=0&id=3e3b62ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3b62ee",
  null
  
)

export default component.exports